import { Icon } from "@iec-id/ui";
import { useTranslation } from "react-i18next";
import { NAV_SECTIONS } from "./nav-config";
import { NavItemLink } from "./nav-link";

/**
 * Левое меню витрины: 220px, строки 56px (макет 2a).
 *
 * Только разделы. «Выйти» живёт в меню аккаунта в шапке — это действие, а не
 * место, и в списке навигации ему делать нечего; там же его ищут по привычке
 * от Яндекс ID и Google Account.
 *
 * «Правовой центр» в сайдбаре не рисуем: документы открываются из меню
 * профиля, там же живёт счётчик непринятых редакций (`AccountButton`).
 * Запись в `NAV_SECTIONS` остаётся — поиск и роут `/legal` живы.
 */
export function SideNav() {
	const { t } = useTranslation("common");

	return (
		<nav aria-label={t("nav.label")} className="w-[220px] shrink-0">
			{NAV_SECTIONS.filter((section) => section.key !== "legal").map((section) => (
				<NavItemLink
					key={section.key}
					to={section.to}
					// Главная активна только по точному совпадению: иначе «/» подсвечен
					// на каждом разделе, ведь любой путь начинается со слеша.
					activeOptions={{ exact: section.to === "/" }}
					activeProps={{ active: true }}
					label={t(section.labelKey)}
					icon={<Icon name={section.icon} />}
				/>
			))}
		</nav>
	);
}
